import { useEffect, useState } from "react";

function getBoxStyle() {
  const isEdge = typeof navigator !== "undefined" && navigator.userAgent.includes("Edg");
  const isTallScreen = typeof window !== "undefined" && window.innerHeight >= 900;
  const isWideScreen = typeof window !== "undefined" && window.innerWidth >= 1280;

  return {
    height: isEdge && isTallScreen && isWideScreen ? "100vh" : "100%",
    overflow: "auto",
  };
}

export function useEdgeBoxStyle() {
  const [style, setStyle] = useState(getBoxStyle);

  useEffect(() => {
    function handleResize() {
      setStyle(getBoxStyle());
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return style;
}